import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSnapshot } from 'valtio';

import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Stack from '@mui/material/Stack';

import AnalyticsIcon from '@mui/icons-material/Analytics';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import GrainIcon from '@mui/icons-material/Grain';
import LanguageIcon from '@mui/icons-material/Language';

import { RouterPaths } from '@/components/pages';

import { appStore } from '@/store';

function AppDrawer() {
  const { t } = useTranslation();
  const snap = useSnapshot(appStore);
  const navigate = useNavigate();

  const handleCloseClick = () => {
    appStore.appDrawer.open = false;
  };

  const handleNavigate = (link: string) => () => {
    navigate(link);
    handleCloseClick();
  };

  return (
    <Drawer
      anchor="left"
      open={snap.appDrawer.open}
      onClose={handleCloseClick}
      sx={{
        width: snap.appDrawer.width,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: snap.appDrawer.width,
          boxSizing: 'border-box',
        },
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="center">
        <img src="/logo-small.webp" width={144} height={56} />
      </Stack>
      <Divider />
      <List>
        <ListSubheader>{t('appDrawer.dashboards')}</ListSubheader>
        <ListItem key="emissions" sx={{ p: 0 }}>
          <ListItemButton
            onClick={handleNavigate(RouterPaths.emissionsAndEnergy)}
          >
            <ListItemIcon>
              <EnergySavingsLeafIcon color="primary" />
            </ListItemIcon>
            <ListItemText>{t('appDrawer.emissionsAndEnergy')}</ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem key="manage-co2e" sx={{ p: 0 }}>
          <ListItemButton onClick={handleNavigate(RouterPaths.manageCo2e)}>
            <ListItemIcon>
              <LanguageIcon color="primary" />
            </ListItemIcon>
            <ListItemText>{t('appDrawer.manageCo2e')}</ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem key="event-map" sx={{ p: 0 }}>
          <ListItemButton onClick={handleNavigate(RouterPaths.eventMap)}>
            <ListItemIcon>
              <GrainIcon color="primary" />
            </ListItemIcon>
            <ListItemText>{t('appDrawer.eventMap')}</ListItemText>
          </ListItemButton>
        </ListItem>
        <ListItem key="reefer-insights" sx={{ p: 0 }}>
          <ListItemButton onClick={handleNavigate(RouterPaths.reeferInsights)}>
            <ListItemIcon>
              <AnalyticsIcon color="primary" />
            </ListItemIcon>
            <ListItemText>{t('appDrawer.reeferInsights')}</ListItemText>
          </ListItemButton>
        </ListItem>
      </List>
    </Drawer>
  );
}

export { AppDrawer };
